module.exports = __webpack_public_path__ + "img/quiz.5847fa8f.png";